import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const PlayerBonuses = Suspendable(
  lazy(() =>
    import('@modules/playerBonuses/controller/PlayerBonusesController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

const PlayerBonusDetails = Suspendable(
  lazy(() =>
    import('@modules/playerBonuses/submodules/PlayerBonusDetails/controller/PlayerBonusDetailsController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

export const PlayerBonusesRoutes: RouteObject[] = [
  {
    element: <PlayerBonuses />,
    path: ROUTES.PLAYER_BONUSES.ROOT,
  },
  {
    element: <PlayerBonusDetails />,
    path: ROUTES.PLAYER_BONUSES.DETAILS,
  },
];
